import { render, staticRenderFns } from "./member_social_links.vue?vue&type=template&id=c69c9774"
import script from "./member_social_links.vue?vue&type=script&lang=js"
export * from "./member_social_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports